import React, { useEffect, useRef } from "react";

const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const targetPos = useRef({ x: -100, y: -100 });
  const ringPos = useRef({ x: -100, y: -100 });
  const rafRef = useRef();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(max-width: 1024px)").matches) return;
    document.body.classList.add("has-custom-cursor");

    const onMove = (e) => {
      targetPos.current.x = e.clientX;
      targetPos.current.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
      }

      // Check for interactive elements inline (avoids separate mouseover listener on every element)
      const interactive = e.target.closest(
        "a, button, [role='button'], input, textarea, select, .magnetic-btn, .filter-pill, .service-card, .project-card"
      );
      if (ringRef.current) {
        if (interactive) ringRef.current.classList.add("expanded");
        else ringRef.current.classList.remove("expanded");
      }
    };

    const animate = () => {
      ringPos.current.x += (targetPos.current.x - ringPos.current.x) * 0.18;
      ringPos.current.y += (targetPos.current.y - ringPos.current.y) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringPos.current.x}px, ${ringPos.current.y}px) translate(-50%, -50%)`;
      }
      rafRef.current = requestAnimationFrame(animate);
    };

    // Use pointermove instead of mousemove (more efficient, covers touch too)
    window.addEventListener("pointermove", onMove, { passive: true });
    rafRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("pointermove", onMove);
      cancelAnimationFrame(rafRef.current);
      document.body.classList.remove("has-custom-cursor");
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="mayak-cursor-dot" data-testid="custom-cursor-dot" />
      <div ref={ringRef} className="mayak-cursor-ring" data-testid="custom-cursor-ring" />
    </>
  );
};

export default CustomCursor;
